// Formatting helpers for cents. The API only ever speaks integer cents.

// Document currencies of invoices and offers (utils/accounting/money.js); EUR is the default.
export const CURRENCIES = ["EUR", "USD"];
const CURRENCY_SYMBOLS = { EUR: "€", USD: "$" };
export const currencySymbol = currency => CURRENCY_SYMBOLS[currency] || "€";

export const formatCents = (cents, { symbol = true, currency = "EUR" } = {}) => {
  const value = Number(cents || 0) / 100;
  const text = new Intl.NumberFormat("de-DE", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(value);
  return symbol ? `${text} ${currencySymbol(currency)}` : text;
};

/** "1.234,56" or "1234.56" → cents. Returns null when not a number. */
export const parseToCents = input => {
  if (input === null || input === undefined || input === "") return null;
  let s = String(input).trim().replace(/[€\s]/g, "");
  if (/,\d{1,2}$/.test(s)) s = s.replace(/\./g, "").replace(",", ".");
  const n = Number(s);
  if (Number.isNaN(n)) return null;
  return Math.round(n * 100);
};

export const formatDate = iso => {
  if (!iso) return "";
  const [y, m, d] = String(iso).slice(0, 10).split("-");
  return d && m && y ? `${d}.${m}.${y}` : String(iso);
};

export const formatPeriod = period => {
  if (!period) return "";
  const [y, m] = period.split("-");
  return `${m}/${y}`;
};
